import axios from "axios";
import constants from "../constants";
const { GET_PAYOUTS, GET_PAYOUTS_SUCCESS, GET_PAYOUTS_ERROR, DELETE_PAYOUT, DELETE_PAYOUT_SUCCESS, DELETE_PAYOUT_ERROR, APPROVE_PAYOUT, APPROVE_PAYOUT_SUCCESS, APPROVE_PAYOUT_ERROR, REJECT_PAYOUT, REJECT_PAYOUT_SUCCESS, REJECT_PAYOUT_ERROR } = constants;

const GET_PAYOUTS_API_URL = process.env.REACT_APP_API_URL + "/api/admin/payouts";
const DELETE_PAYOUT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/delete-payout";
const APPROVE_PAYOUT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/approve-payout";
const REJECT_PAYOUT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/reject-payout";

export const getPayoutsAction = (config) => async (dispatch) => {
  dispatch({ type: GET_PAYOUTS })
  await axios.get(GET_PAYOUTS_API_URL, config)
    .then((res) => dispatch({ type: GET_PAYOUTS_SUCCESS, payouts: res?.data?.payouts }))
    .catch((error) => dispatch({ type: GET_PAYOUTS_ERROR, error }))
}

export const deletePayoutAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: DELETE_PAYOUT })
  await axios.post(DELETE_PAYOUT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: DELETE_PAYOUT_SUCCESS, message: res?.data?.message })
      callback();
    })
    .catch((error) => dispatch({ type: DELETE_PAYOUT_ERROR, error }))
}

export const approvePayoutAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: APPROVE_PAYOUT })
  await axios.post(APPROVE_PAYOUT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: APPROVE_PAYOUT_SUCCESS, message: res?.data?.message })
      callback();
    })
    .catch((error) => dispatch({ type: APPROVE_PAYOUT_ERROR, error }))
}

export const rejectPayoutAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: REJECT_PAYOUT })
  await axios.post(REJECT_PAYOUT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: REJECT_PAYOUT_SUCCESS, message: res?.data?.message })
      callback();
    })
    .catch((error) => dispatch({ type: REJECT_PAYOUT_ERROR, error }))
}
